"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightDiv = exports.LeftDiv = exports.ItensContainer = exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _atoms = require("../../atoms");
var _util = _interopRequireDefault(require("../../../themes/base/util"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["animationPosition"],
  _excluded2 = ["show"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var sizeAdapter = _util["default"].sizeAdapter;
var Container = exports.Container = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: row;\n  height: 64px;\n  position: relative;\n  overflow: hidden;\n  z-index: auto;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding-left: var(--spacing-2);\n"])));
var _ItensContainer = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var animationPosition = _ref.animationPosition,
    others = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_atoms.View, _objectSpread({
    ref: ref
  }, others));
}); // eslint-disable-line react/prop-types

var ItensContainer = exports.ItensContainer = (0, _styledComponents["default"])(_ItensContainer)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  flex-direction: row;\n  flex-grow: 1;\n  flex-flow: auto;\n  transition: all 0.5s cubic-bezier(0.55, 0.01, 0.49, 1);\n  ", ";\n  width: 100%;\n"])), function (_ref2) {
  var animationPosition = _ref2.animationPosition;
  return animationPosition ? "transform: translateX(".concat(sizeAdapter(animationPosition), ")") : null;
});
var Arrow = function Arrow(_ref3) {
  var show = _ref3.show,
    others = _objectWithoutProperties(_ref3, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_atoms.View, _objectSpread({}, others));
}; // eslint-disable-line react/prop-types

var arrowContainer = (0, _styledComponents["default"])(Arrow)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  bottom: 0;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  width: 48px;\n  z-index: 999;\n"])));
var LeftDiv = exports.LeftDiv = (0, _styledComponents["default"])(arrowContainer)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  background: linear-gradient(to right, #fff 66%, rgba(255, 255, 255, 0));\n  left: 0;\n  margin-left: -12px;\n  padding-left: var(--spacing-1);\n  visibility: ", ";\n  color: var(--color-secondary-100);\n"])), function (props) {
  return props.show ? 'visible' : 'hidden';
});
var RightDiv = exports.RightDiv = (0, _styledComponents["default"])(arrowContainer)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  align-items: flex-end;\n  background: linear-gradient(to left, #fff 66%, rgba(255, 255, 255, 0));\n  padding-right: var(--spacing-1);\n  right: 0;\n  visibility: ", ";\n  color: var(--color-secondary-100);\n"])), function (props) {
  return props.show ? 'visible' : 'hidden';
});